import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ProductCard } from '../components/ProductCard';
import { FilterIcon, SlidersIcon, ChevronRightIcon } from 'lucide-react';
export const CategoryPage = () => {
  const {
    categoryName
  } = useParams();
  const [priceRange, setPriceRange] = useState([0, 2000]);
  // Mock data
  const products = [{
    id: 'iphone-15',
    name: 'iPhone 15',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/adSmqXZtwMRaADCVDQGH75/image.png',
    startingPrice: 799
  }, {
    id: 'iphone-14',
    name: 'iPhone 14',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 699
  }, {
    id: 'iphone-13',
    name: 'iPhone 13',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 599
  }, {
    id: 'iphone-12',
    name: 'iPhone 12 mini',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 499
  }, {
    id: 'iphone-11',
    name: 'iPhone 11',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 399
  }, {
    id: 'iphone-xr',
    name: 'iPhone XR',
    brand: 'Apple',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mpUWfge48LzYAT2RB4n7mg/image.png',
    startingPrice: 299
  }];
  const formatCategoryName = (name: string | undefined) => {
    if (!name) return '';
    return name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  return <main className="container mx-auto px-4 py-6" data-id="element-2328">
      {/* Breadcrumb */}
      <div className="flex items-center text-sm text-gray-500 mb-6" data-id="element-2329">
        <Link to="/" className="hover:text-blue-600" data-id="element-2330">
          Home
        </Link>
        <ChevronRightIcon className="h-4 w-4 mx-2" data-id="element-2331" />
        <span className="text-gray-900" data-id="element-2332">
          Buy {formatCategoryName(categoryName)}
        </span>
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2333">Apple iPhone</h1>
      <p className="text-gray-600 mb-8" data-id="element-2334">Browse our collection of products</p>
      <div className="flex flex-col lg:flex-row gap-8" data-id="element-2335">
        {/* Sidebar filters */}
        <div className="w-full lg:w-1/4" data-id="element-2336">
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-2337">
            <h2 className="font-bold text-lg mb-4" data-id="element-2338">Categories</h2>
            <ul className="space-y-2 mb-6" data-id="element-2339">
              <li data-id="element-2340">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2341">
                  Smartphone
                </a>
              </li>
              <li className="pl-4" data-id="element-2342">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2343">
                  Nokia
                </a>
              </li>
              <li className="pl-4 font-medium text-blue-600" data-id="element-2344">
                <a href="#" data-id="element-2345">Apple iPhone</a>
              </li>
              <li className="pl-8" data-id="element-2346">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2347">
                  iPhone 12 series
                </a>
              </li>
              <li className="pl-8" data-id="element-2348">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2349">
                  iPhone 11 series
                </a>
              </li>
              <li className="pl-8" data-id="element-2350">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2351">
                  iPhone X, XR, XS, XSM series
                </a>
              </li>
              <li className="pl-8" data-id="element-2352">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2353">
                  iPhone low model
                </a>
              </li>
              <li data-id="element-2354">
                <a href="#" className="text-gray-700 hover:text-blue-600" data-id="element-2355">
                  See more
                </a>
              </li>
            </ul>
            <h2 className="font-bold text-lg mb-4" data-id="element-2356">Price ($)</h2>
            <div className="mb-6" data-id="element-2357">
              <input type="range" min="0" max="2000" className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer" data-id="element-2358" />
              <div className="flex justify-between mt-2" data-id="element-2359">
                <div data-id="element-2360">
                  <label className="block text-sm text-gray-600 mb-1" data-id="element-2361">
                    Min ($)
                  </label>
                  <input type="number" value={priceRange[0]} onChange={e => setPriceRange([parseInt(e.target.value), priceRange[1]])} className="w-24 border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-2362" />
                </div>
                <div className="flex items-center mt-6" data-id="element-2363">-</div>
                <div data-id="element-2364">
                  <label className="block text-sm text-gray-600 mb-1" data-id="element-2365">
                    Max ($)
                  </label>
                  <input type="number" value={priceRange[1]} onChange={e => setPriceRange([priceRange[0], parseInt(e.target.value)])} className="w-24 border border-gray-300 rounded px-2 py-1 text-sm" data-id="element-2366" />
                </div>
              </div>
            </div>
            <h2 className="font-bold text-lg mb-4" data-id="element-2367">Built-In Storage</h2>
            <div className="space-y-2 mb-6" data-id="element-2368">
              <label className="flex items-center" data-id="element-2369">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2370" />
                <span className="ml-2 text-gray-700" data-id="element-2371">16GB</span>
              </label>
              <label className="flex items-center" data-id="element-2372">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2373" />
                <span className="ml-2 text-gray-700" data-id="element-2374">32GB</span>
              </label>
              <label className="flex items-center" data-id="element-2375">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2376" />
                <span className="ml-2 text-gray-700" data-id="element-2377">64GB</span>
              </label>
              <label className="flex items-center" data-id="element-2378">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2379" />
                <span className="ml-2 text-gray-700" data-id="element-2380">128GB</span>
              </label>
              <label className="flex items-center" data-id="element-2381">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2382" />
                <span className="ml-2 text-gray-700" data-id="element-2383">256GB</span>
              </label>
            </div>
            <h2 className="font-bold text-lg mb-4" data-id="element-2384">Condition</h2>
            <div className="space-y-2" data-id="element-2385">
              <label className="flex items-center" data-id="element-2386">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2387" />
                <span className="ml-2 text-gray-700" data-id="element-2388">Fair</span>
              </label>
              <label className="flex items-center" data-id="element-2389">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2390" />
                <span className="ml-2 text-gray-700" data-id="element-2391">Good</span>
              </label>
              <label className="flex items-center" data-id="element-2392">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2393" />
                <span className="ml-2 text-gray-700" data-id="element-2394">Excellent</span>
              </label>
              <label className="flex items-center" data-id="element-2395">
                <input type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-2396" />
                <span className="ml-2 text-gray-700" data-id="element-2397">Brand New</span>
              </label>
            </div>
          </div>
        </div>
        {/* Main content */}
        <div className="w-full lg:w-3/4" data-id="element-2398">
          <div className="flex justify-between items-center mb-6" data-id="element-2399">
            <button className="flex items-center text-gray-700 bg-white rounded-md px-4 py-2 shadow-sm" data-id="element-2400">
              <FilterIcon className="h-5 w-5 mr-2" data-id="element-2401" /> Filters
            </button>
            <div className="flex items-center" data-id="element-2402">
              <span className="text-gray-600 mr-2" data-id="element-2403">Sort by</span>
              <select className="border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2404">
                <option data-id="element-2405">Relevance</option>
                <option data-id="element-2406">Price: Low to High</option>
                <option data-id="element-2407">Price: High to Low</option>
                <option data-id="element-2408">Newest First</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2409">
            {products.map(product => <ProductCard key={product.id} product={product} data-id="element-2410" />)}
          </div>
          <div className="mt-8 flex justify-center" data-id="element-2411">
            <button className="bg-white text-blue-600 border border-blue-600 rounded-md px-6 py-2 hover:bg-blue-50 transition-colors" data-id="element-2412">
              Load more
            </button>
          </div>
        </div>
      </div>
    </main>;
};